<template>
  <button
    :class="buttonClasses"
    type="button"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="flex items-center">
      <div
        v-if="loading"
        class="loader mr-2"
      />
      <slot />
    </div>
  </button>
</template>

<script>
import WButton from './WButton';

export default WButton;
</script>

<style lang="scss" scoped>
@import 'WButton';
</style>
